// ✅ src/types/langTypes.ts
export enum LangCode {
  UA = 'ua',
  GB = 'gb',
  PL = 'pl',
  DE = 'de',
  FR = 'fr',
  IT = 'it',
}

export const LANG_CODES: LangCode[] = [
  LangCode.UA,
  LangCode.GB,
  LangCode.PL,
  LangCode.DE,
  LangCode.FR,
  LangCode.IT,
];

export interface BenefitItem {
  id: string;
  title: string;
  description: string;
  icon?: React.ComponentType<{ className?: string }>;
}

export type LangData = {
  id: string;
  name: string;
  images: string[];
  altText: string;
  description: string; // строго string
  portfolioDescription1: string;
  portfolioDescription2: string;
  portfolioDescription3: string;
  portfolioDescription4: string;
  portfolioDescription5: string;
  portfolioDescription6: string;

  "impressum.back": string;
  "impressum.subtitle": string;
  "impressum.infoTitle": string;
  "impressum.owner": string;
  "impressum.address": string;
  "impressum.city": string;
  "impressum.contactTitle": string;
  "impressum.email": string;
  "impressum.website": string;
  "impressum.copyrightTitle": string;
  "impressum.copyrightText": string;
  "impressum.rights": string;
  "impressum.disputeTitle": string;
  "impressum.disputeText": string;
  "impressum.disputeFinal": string;
  "impressum.disclaimerTitle": string;
  "impressum.disclaimerText": string;
  "impressum.taxStatus": string;
  "impressum.responsible": string;
  "impressum.phone": string;
  "impressum.copyrightLinkText": string;
  "privacy.title": string;
  "privacy.intro": string;
  "privacy.hostingTitle": string;
  "privacy.hostingText": string;
  "privacy.dataText": string;
  "privacy.dataTitle": string;
  "privacy.rightsTitle": string; 
  "privacy.rightsText": string; 
  "privacy.contactTitle": string; 
  "privacy.contactText": string;





  link?: string;
  portfolioDescription: string;
  backToTop: string;
  home: string;
  about: string;
  aboutTitle: string;
  aboutText: string;
  aboutSubtitle: string;
  aboutButton: string;
  aboutButtonText: string;
  aboutButtonLink: string;
  aboutImageAlt: string;
  aboutList: string[];
  aboutQuote: string;
  aboutQuoteAuthor: string;
  aboutStats: { label: string; value: string }[];
  aboutMission: string;
  aboutVision: string;
  aboutValues: string[];
  aboutTeam: string;
  aboutPartners: string;
  aboutClients: string;
  aboutHistory: string;
  aboutmain: string;
  aboutPhilosophyTitle: string;
  aboutPhilosophyText: string;


  

  services: string;
  servicesTitle: string;
  servicesContactText: string;
  servicesButton: string;
  servicesFormTitle: string;
  servicesFormPlaceholder: string;
  servicesFormButton: string;
  showLessButton: string; 
  showMoreButton: string; 

  portfolio: string;
  portfolioTitle: string;
  portfolioText: string;
  portfolioLabel: string;

  testimonials: string;
  testimonialsText: string;

  blogTitle: string;

  contacts: string;
  contactsTitle: string;
  phone: string;
  email: string;

  faq: string;
  partnership: string;

  showAllButton: string;
  hideAllButton: string;

  title: string;
  subtitle: string[];
  button: string;

  benefitsTitle: string;
  benefitsSubtitle: string;
  benefitsText: string;
  benefits: BenefitItem[];

  goTo: string;
  footer: string;

  heroTitle: string;
  heroSubtitle: string[];
  heroButton: string;

  portfolioLink: string;
  portfolioLinkText: string;
  viewOnGithub: string;
  noProjectsFound: string;

  serviceDetailsTitle: string;
  serviceDetailsText: string;
  servicesDetailsButton: string;
  servicesDetailsSubtitle: string;
  servicesDetailsList: string[];

  notFoundTitle: string;
  notFoundText: string;
  notFoundButton: string;

  cookieConsentText: string;
  cookieConsentButton: string;
  privacyPolicy: string;
  termsOfService: string;
  loading: string;
  error: string;
  success: string;
  language: string;
  selectLanguage: string;
  close: string;

  serviceDetailsBack: string;
  faqTitle: string;
  faqSubtitle: string;
  faqText: string;
  team: string;
  teamTitle: string;
  teamText: string;
  process: string;
  processTitle: string;
  processText: string;
  technologies: string;
  technologiesTitle: string;
  technologiesText: string;
  price: string;
  priceTitle: string;
  priceText: string;

  processSubtitle: string;
  teamSubtitle: string;
  teamButton: string;
  teamButtonText: string;
  processButton: string;
  processButtonText: string;
  technologiesSubtitle: string;
  technologiesButton: string;
  technologiesButtonText: string;
  priceSubtitle: string;
  priceButton: string;
  priceButtonText: string;

  teamButtonLink: string;
  portfolioButton: string;
  portfolioButtonText: string;
  portfolioButtonLink: string;
  blogButton: string;
  blogButtonText: string;
  blogButtonLink: string;
  contactsButton: string;
  contactsButtonText: string;
  contactsButtonLink: string;
  faqButton: string;
  faqButtonText: string;
  faqButtonLink: string;
  notFoundButtonText: string;
  cookieConsentMore: string;
  privacyPolicyButton: string;
  termsOfServiceButton: string;

  contactsButtonLinkText: string;
  cookieConsentLink: string;
  privacyPolicyButtonText: string;
  termsOfServiceButtonText: string;
  aboutButtonLinkText: string;
  servicesButtonLinkText: string;
  portfolioButtonLinkText: string;
  blogButtonLinkText: string;
  faqButtonLinkText: string;
  teamButtonLinkText: string;
  processButtonLinkText: string;
  technologiesButtonLinkText: string;
  priceButtonLinkText: string;
  notFoundButtonLinkText: string;
  cookieConsentButtonText: string;
  cookieConsentMoreText: string;

  faqQuestion: string;
  faqAnswer: string;
  priceButtonLink: string;
  processButtonLink: string;
  technologiesButtonLink: string;
  servicesButtonLink: string;
  notFoundButtonLink: string;
  privacyPolicyLink: string;
  termsOfServiceLink: string;

  partnershipTitle: string;
  partnershipSubtitle: string;
  partnershipText: string;
  notFoundBackButton: string;
  extraField1: string;
  extraField2: string;

  noPortfolioItems: string;
  noImages: string;



  mainNavigation: string[];
  mainNavigationLabel: string;
  toggleMenu: string;

  notFoundLink: string;
  cookieConsent: string;
  logoTaglines: {
    top: string;
    bottom: string;
  };
};

export type TFunction = <K extends keyof LangData>(key: K) => LangData[K];
export type TranslateString = <K extends keyof LangData>(key: K) => string;
